module.exports = __webpack_public_path__ + "static/media/back_of_left_thumb_failed.6244b6ef.svg";